import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import "./PrivacyPolicy.scss";
import AppContainer from "../../components/app-container/AppContainer";
import { useDocumentTitle } from "../../components/title/DocumentTitle";

import tenantService from "../../services/TenantService";
import { Etracker } from "spot-component-library/lib/components/etracker/Etracker";
import { readLanguageFromCookie } from "../../components/GeneralUtils";

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const [tenant, setTenant] = React.useState<string>("");
    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        const tenant = await tenantService.getTenant();
        setTenant(tenant);
    };

    useDocumentTitle(t("PRIVACY_POLICY.TITLE"));

    return (
        <>
            <AppContainer header={{ menuLoginEnabled: false }}>
                <Etracker pageName={"Privacy_Page"} popto={"1500"} tenant={tenant.toString()} language={readLanguageFromCookie()} />
                <div className={"privacy-policy-page"}>
                    <h1 role="heading">{t("PRIVACY_POLICY.TITLE")}</h1>
                    <h2>{t("PRIVACY_POLICY.DATA_PROCESSING_INFORMATION")}</h2>
                    <section>
                        <Trans i18nKey="PRIVACY_POLICY.DATA_PROCESSING_INFORMATION_TEXT" />
                    </section>

                    <h2>{t("PRIVACY_POLICY.1_DATA_CONTROLLER_CONTACT.TITLE")}</h2>

                    <section>
                        <Trans
                            i18nKey="PRIVACY_POLICY.1_DATA_CONTROLLER_CONTACT.CONTENT"
                            components={{
                                link1: <a href={t("PRIVACY_POLICY.1_DATA_CONTROLLER_CONTACT.LINK_1")} />,
                                link2: <a href={t("PRIVACY_POLICY.1_DATA_CONTROLLER_CONTACT.LINK_2")} />,
                            }}
                        />
                    </section>

                    <h2>{t("PRIVACY_POLICY.2_SCOPE.TITLE")}</h2>

                    <section>
                        <Trans
                            i18nKey="PRIVACY_POLICY.2_SCOPE.CONTENT"
                            components={{
                                link1: <a href={t("PRIVACY_POLICY.2_SCOPE.LINK_1")} />,
                            }}
                        />
                    </section>

                    <h2>{t("PRIVACY_POLICY.3_PERSONAL_DATA.TITLE")}</h2>

                    <section>
                        <Trans
                            i18nKey="PRIVACY_POLICY.3_PERSONAL_DATA.CONTENT"
                            components={{
                                link1: <a href={t("PRIVACY_POLICY.3_PERSONAL_DATA.LINK")} />,
                            }}
                        />
                    </section>

                    <h2>{t("PRIVACY_POLICY.4_DATA_DISCLOSURE.TITLE")}</h2>
                    <section>
                        <Trans
                            i18nKey="PRIVACY_POLICY.4_DATA_DISCLOSURE.CONTENT"
                            components={{
                                link1: <a href={t("PRIVACY_POLICY.4_DATA_DISCLOSURE.LINK_1")} />,
                            }}
                        />
                    </section>

                    <h2>{t("PRIVACY_POLICY.51_DATA.TITLE")}</h2>
                    <section>
                        <Trans
                            i18nKey="PRIVACY_POLICY.51_DATA.CONTENT"
                            components={{
                                link1: <a href={t("PRIVACY_POLICY.51_DATA.LINK1")} />,
                            }}
                        />
                    </section>

                    <h2>{t("PRIVACY_POLICY.5_COOKIES.TITLE")}</h2>
                    <section>
                        <Trans
                            i18nKey="PRIVACY_POLICY.5_COOKIES.CONTENT"
                            components={{
                                link1: <a href={t("PRIVACY_POLICY.5_COOKIES.LINK")} />,
                            }}
                        />
                        <div className={"session-privacy-table-container"}>
                            <table className={"session-privacy-table"}>
                                <Trans i18nKey="PRIVACY_POLICY.5_COOKIES.TABLE" />
                            </table>
                        </div>
                    </section>

                    <h2>{t("PRIVACY_POLICY.6_ANALYSIS_TOOL.TITLE")}</h2>
                    <section>
                        <Trans
                            i18nKey="PRIVACY_POLICY.6_ANALYSIS_TOOL.CONTENT"
                            components={{
                                link1: <a href={t("PRIVACY_POLICY.6_ANALYSIS_TOOL.LINK1")} target={"_blank"} />,
                                link2: <a href={t("PRIVACY_POLICY.6_ANALYSIS_TOOL.LINK2")} target={"_blank"} />,
                                link3: <a href={t("PRIVACY_POLICY.6_ANALYSIS_TOOL.LINK3")} target={"_blank"} />,
                                link4: <a href={t("PRIVACY_POLICY.6_ANALYSIS_TOOL.LINK4")} target={"_blank"} />,
                                link5: <a href={t("PRIVACY_POLICY.6_ANALYSIS_TOOL.LINK5")} target={"_blank"} />,
                            }}
                        />
                        <br />
                        {tenant != "fr-eos" && (
                            <div>
                                <a href="#" data-language="en" data-tld={t("PRIVACY_POLICY.6_ANALYSIS_TOOL.LINK_ETRACKER_EOS")} id="et-opt-out" />
                                <br />
                                <br />
                                <Trans
                                    i18nKey="PRIVACY_POLICY.6_ANALYSIS_TOOL.PRIVACY_INFO"
                                    components={{
                                        link1: <a href={t("PRIVACY_POLICY.6_ANALYSIS_TOOL.LINK_ETRACKER_PRIVACY")} target={"_blank"} />,
                                    }}
                                />
                            </div>
                        )}
                    </section>

                    <h2>{t("PRIVACY_POLICY.7_DATA_SUBJECTS_RIGHTS.TITLE")}</h2>
                    <section>
                        <Trans
                            i18nKey="PRIVACY_POLICY.7_DATA_SUBJECTS_RIGHTS.CONTENT"
                            components={{
                                link1: <a href={t("PRIVACY_POLICY.7_DATA_SUBJECTS_RIGHTS.LINK_1")} />,
                                link2: <a href={t("PRIVACY_POLICY.7_DATA_SUBJECTS_RIGHTS.LINK_2")} />,
                                link3: <a href={t("PRIVACY_POLICY.7_DATA_SUBJECTS_RIGHTS.LINK_3")} target={"_blank"} />,
                            }}
                        />
                        <br />
                        {tenant == "fr-eos" && (
                            <div>
                                <a href="#" data-language="en" data-tld={t("PRIVACY_POLICY.6_ANALYSIS_TOOL.LINK_ETRACKER_EOS")} id="et-opt-out" />
                                <br />
                                <br />
                                <Trans
                                    i18nKey="PRIVACY_POLICY.6_ANALYSIS_TOOL.PRIVACY_INFO"
                                    components={{
                                        link1: <a href={t("PRIVACY_POLICY.6_ANALYSIS_TOOL.LINK_ETRACKER_PRIVACY")} target={"_blank"} />,
                                    }}
                                />
                            </div>
                        )}
                    </section>

                    <h2>{t("PRIVACY_POLICY.8_DATA_SECURITY.TITLE")}</h2>
                    <section>
                        <Trans
                            i18nKey="PRIVACY_POLICY.8_DATA_SECURITY.CONTENT"
                            components={{
                                link1: <a href={t("PRIVACY_POLICY.8_DATA_SECURITY.LINK_1")} />,
                                link2: <a href={t("PRIVACY_POLICY.8_DATA_SECURITY.LINK_2")} />,
                            }}
                        />
                    </section>

                    <h2>{t("PRIVACY_POLICY.9_UPDATING_PRIVACY_POLICY.TITLE")}</h2>
                    <section>
                        <Trans i18nKey="PRIVACY_POLICY.9_UPDATING_PRIVACY_POLICY.CONTENT" />
                    </section>

                    <h2>{t("PRIVACY_POLICY.10_BLOCK.TITLE")}</h2>
                    <section>
                        <Trans i18nKey="PRIVACY_POLICY.10_BLOCK.CONTENT" />
                    </section>
                </div>
            </AppContainer>
        </>
    );
};
export default PrivacyPolicy;
